import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "~/lib/utils";
import type { CartProductAttribute } from "~/lib/use-embedded-cart-global";

interface VariantAttributeSelectorProps {
  attribute: CartProductAttribute;
  value: string;
  onChange: (value: string) => void;
}

// One row of pill-style options for a single variant attribute (e.g. Connector Type:
// J1772/NACS). Uses Radix's RadioGroup for a11y, styled as boxes rather than circles
// (data-[state=checked] mirrors ui/tabs.tsx's active-state convention).
export function VariantAttributeSelector({ attribute, value, onChange }: VariantAttributeSelectorProps) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-text-body text-sm font-bold">
        {attribute.key}: <span className="font-normal">{value}</span>
      </span>
      <RadioGroupPrimitive.Root value={value} onValueChange={onChange} className="flex flex-wrap gap-2" aria-label={attribute.key}>
        {attribute.values.map(({ key: optionValue }) => (
          <RadioGroupPrimitive.Item
            key={optionValue}
            value={optionValue}
            className={cn(
              "border-border text-text-body cursor-pointer rounded-md border-2 px-4 py-2 text-sm font-bold transition-colors",
              "hover:border-bouncie-500",
              "focus-visible:ring-ring focus-visible:outline-none focus-visible:ring-1",
              "data-[state=checked]:border-bouncie-500 data-[state=checked]:text-bouncie-500",
            )}
          >
            {optionValue}
          </RadioGroupPrimitive.Item>
        ))}
      </RadioGroupPrimitive.Root>
    </div>
  );
}
